import React from "react";

const H1BVisa: React.FC = () => {
  return (
 <div className="max-w-7xl  bg-white min-h-screen text-left flex flex-col items-center py-10 px-4 pt-20">
   
          <div className="text-[22px] text-gray-700 mb-4">This page is under construction.</div>

  </div>
  );
};

export default H1BVisa;
